module.exports = __webpack_public_path__ + "static/media/cigarettes_03_full.f966a1b1.png";